<template>
    <div class="container">
        <scroll-wrap></scroll-wrap>
        <menu-list></menu-list>
        <div class="main">
            <div class="chat-list">
                <div class="send-wrap">
                    <div class="img">
                        <img :src="$store.state.user.sellerImage" alt="">
                    </div>
                    <div class="name">
                        <span>{{$store.state.user.seller}}</span>
                    </div>
                </div>
                <div class="acceptor-wrap">
                    <scroll-wrap>
                        <div v-if="message.list.length>0">
                            <div class="acceptor-item" :class="{active:currentChatId===item.id}"
                                 v-for="(item,index) in message.list" :key="index" @click="openMessage(item)">
                                <div class="img">
                                    <img :src="item.buyerImage" alt="">
                                </div>
                                <div class="center-txt">
                                <span class="name">
                                    {{item.buyer}}
                                </span>
                                    <span class="message">
                                    {{item.message?item.message.content:''}}
                                </span>
                                </div>
                                <div class="date-num">
                                    <span v-if="new Date().setHours(0, 0, 0, 0)<(item.message?item.message.senderTime:item.createTime)">
                                        {{new Date(item.message?(item.message.receiveTime ? item.message.receiveTime : item.message.senderTime):item.createTime).$Format('hh:mm')}}
                                    </span>
                                    <span v-else>
                                        {{new Date(item.message?(item.message.receiveTime ? item.message.receiveTime : item.message.senderTime):item.createTime).$Format('MM-dd')}}
                                    </span>
                                    <span v-if="item.ctxReady>0">
                                        <i>{{item.ctxReady}}</i>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </scroll-wrap>
                </div>
            </div>
            <div class="chat-wrap">
                <div class="current-chat-name">
                    {{chat.buyer.buyer}}
                </div>
                <div class="current-chat-wrap">
                    <scroll-wrap id="seller">
                        <div class="current-chat-list" v-if="chat.list.length>0">
                            <div class="chat-item-wrap" v-for="(item,index) in chat.list" :key="index"
                                 :class="{my:item.direction===1}">
                                <div class="line" :class="{active:lineActiev(item,chat.list[index-1],index)}">
                                    —— {{new Date(item.senderTime).$Format('yyyy-MM-dd hh:mm')}} ——
                                </div>
                                <div class="item my">
                                    <div class="img">
                                        <img :src="item.receiver.sellerImage" alt="" v-if="item.direction===1">
                                        <img :src="item.receiver.buyerImage" alt="" v-else>
                                    </div>
                                    <div class="content">
                                        {{item.content}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </scroll-wrap>
                </div>
                <div class="current-chat-input">
                    <div class="view">
                        <div class="input-wrap">
                            <textarea class="textareaChatValue" v-model="chat.value" @keydown.enter="sendMessage"></textarea>
                        </div>
                    </div>
                    <div class="send" @click="sendMessage">
                        <i class="el-icon-s-promotion"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>

    import SockJS from "sockjs-client"

    export default {
        name: "service",
        components: {},
        data() {
            return {
                message: {
                    list: []
                },
                chat: {
                    list: [],
                    buyer: {},
                    value: ''
                },
                clientListShow: true,
                currentChatId: ''
            }
        },
        created() {
            this.initClient()
        },
        methods: {
            lineActiev(item,item_1,index){
                if(index===0) return true
                return item.senderTime - item_1.senderTime > 3600000;

            },
            initClient() {
                this.client = new SockJS("/ws-chat-js?type=1");
                this.client.onopen = () => {
                }
                this.handlerMessage()
            },
            openMessage(item) {
                if (item) {
                    this.chat.buyer = item;
                    this.currentChatId = item.id;
                }
                let message = {
                    handler: 'CurrentSession',
                    target: {
                        UserId: this.chat.buyer.id,
                        VersionId: 1,
                        MessageType: 'CUSTOMER'
                    }
                }
                this.client.send(JSON.stringify(message));
                this.handlerMessage().then(() => {
                    document.querySelector("#seller").children[0].scrollTop =
                        document.querySelector("#seller").children[0].scrollHeight -
                        document.querySelector("#seller").children[0].clientHeight

                })
            },
            handlerMessage() {
                return new Promise((resolve) => {
                    this.client.onmessage = (message) => {
                        let $message = JSON.parse(message.data);
                        switch ($message.operator) {
                            case 'UserList':
                                this.message.list = $message.items;
                                resolve()
                                break;
                            case 'InitMessage':
                                this.chat.list = $message.items
                                resolve()
                                break;
                            case 'FutureMessage':
                                this.chat.list = this.chat.list.concat($message.items);
                                this.$nextTick(() => {
                                    document.querySelector("#seller").children[0].scrollTop =
                                        document.querySelector("#seller").children[0].scrollHeight -
                                        document.querySelector("#seller").children[0].clientHeight
                                })

                                resolve()
                                break;
                        }
                    }
                })

            },
            closeMessage() {
                this.client.onclose = function () {
                    console.log('close', arguments);
                }
            },
            sendMessage() {
                if(this.chat.value.trim()===''){
                    document.querySelector('.textareaChatValue').focus()
                    return false;
                }
                this.axios.post("/student/customer/message/sender", {
                    type: 1,
                    receiverId: this.chat.buyer.id,
                    messageType: 'CUSTOMER',
                    content: this.chat.value
                }).then(res => {
                    if (res.succeed) {
                        // this.openMessage();
                        this.chat.value = "";
                        this.handlerMessage().then(() => {
                            document.querySelector("#seller").children[0].scrollTop =
                                document.querySelector("#seller").children[0].scrollHeight -
                                document.querySelector("#seller").children[0].clientHeight
                        })
                    }
                })
            }
        },
        beforeDestroy() {
            this.client.close()
        }
    }
</script>

<style scoped lang="scss">

    .main {
        display: flex;
        border-radius: 10px;
        overflow: hidden;
        height: calc(100vh - 216px);
        width: 1200px;

        .chat-list {
            width: 320px;
            /*height: 800px;*/

            background: #5158b0;
            flex-shrink: 0;
            display: flex;
            padding-top: 100px;
            position: relative;
            box-sizing: border-box;

            > div.send-wrap {
                width: 100%;
                height: 100px;
                display: flex;
                align-items: center;
                padding: 0 16px;
                box-sizing: border-box;
                border-bottom: 1px solid #5b63be;
                background-color: #414aa9;
                position: absolute;
                top: 0;
                left: 0;

                > .img {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 12px;
                    flex-shrink: 0;
                    flex-grow: 0;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                > .name {
                    flex-shrink: 1;
                    flex-grow: 1;
                    font-size: 16px;
                    color: #FFFFFF;
                    word-break: break-all;
                }
            }

            > div.acceptor-wrap {
                width: 100%;

                div.acceptor-item {
                    height: 90px;
                    display: flex;
                    align-items: center;
                    color: #ffffff;
                    padding: 0 16px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #454DAB;
                    transition: background 0.3s linear;
                    cursor: pointer;
                    position: relative;

                    &.active {
                        background: #3a419c;

                        &:before {
                            content: '';
                            width: 4px;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            top: 0;
                            background: #ff66a6;
                        }
                    }

                    &:hover {
                        background: #3a419c;
                        transition: background 0.3s linear;
                    }

                    > .img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 12px;
                        flex-shrink: 0;
                        flex-grow: 0;

                        > img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    > .center-txt {
                        flex-shrink: 1;
                        flex-grow: 1;
                        display: flex;
                        overflow: hidden;
                        flex-direction: column;
                        font-size: 16px;
                        line-height: 28px;
                        height: 56px;

                        > span.message {
                            color: #8FD1D8;
                            font-size: 13px;
                            letter-spacing: 1px;
                            text-overflow: ellipsis;
                            line-height: 28px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                        }
                    }

                    > .date-num {
                        width: 50px;
                        height: 56px;
                        flex-shrink: 0;
                        flex-grow: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;

                        > span {
                            text-align: right;
                            color: #63BFC9;
                            font-size: 14px;
                            line-height: 28px;

                            > i {
                                width: 20px;
                                height: 20px;
                                margin: 4px;
                                display: flex;
                                padding-right: 1px;
                                padding-bottom: 1px;
                                box-sizing: border-box;
                                justify-content: center;
                                align-items: center;
                                background: #ff8700;
                                border-radius: 50%;
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }

        .chat-wrap {
            flex-shrink: 1;
            flex-grow: 1;
            height: 100%;
            background: #EDEDED;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            div.current-chat-name {
                padding: 0 20px;
                font-weight: bolder;
                color: #3a419c;
                font-size: 24px;
                height: 56px;
                line-height: 56px;
                border-bottom: 1px solid #DCDCDD;
                flex-shrink: 0;
                flex-grow: 0;
            }

            div.current-chat-wrap {
                flex-shrink: 1;
                flex-grow: 1;
                height: calc(100% - 227px);
                box-sizing: border-box;
                border-bottom: 1px solid #DCDCDD;

                div.current-chat-list {
                    div.chat-item-wrap {
                        width: 100%;
                        display: flex;
                        align-items: flex-start;
                        padding: 0 20px;
                        box-sizing: border-box;
                        flex-direction: column;

                        div.line {
                            width: 100%;
                            text-align: center;
                            font-size: 12px;
                            margin: 10px 0;
                            color: #9e9e9e;
                            display: none;
                            &.active {
                                display: block;
                            }
                        }


                        div.item {
                            width: 76%;
                            display: flex;
                            margin: 12px 0;

                            > .img {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                overflow: hidden;
                                margin-right: 16px;
                                flex-shrink: 0;
                                flex-grow: 0;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            > .content {
                                background: #ffffff;
                                border-radius: 10px;
                                padding: 14px;
                                position: relative;
                                word-break: break-all;
                                line-height: 22px;
                                font-size: 14px;
                            }
                        }
                    }

                    div.chat-item-wrap.my {
                        flex-direction: column;
                        align-items: flex-end;

                        div.item {
                            width: 76%;
                            display: flex;
                            flex-direction: row-reverse;
                            margin: 12px 0;

                            > .img {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                overflow: hidden;
                                margin-left: 16px;
                                flex-shrink: 0;
                                flex-grow: 0;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            > .content {
                                position: relative;
                                background: #D5D7F3;
                            }
                        }
                    }
                }
            }

            div.current-chat-input {
                flex-shrink: 0;
                flex-grow: 0;
                height: 160px;
                padding: 20px;
                box-sizing: border-box;
                position: relative;

                div.view {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    border-radius: 8px;

                    div.input-wrap {
                        height: 100%;
                        margin-right: -17px;

                        textarea {
                            resize: none;
                            width: 100%;
                            height: 100%;
                            border: none;
                            outline: none;
                            padding: 10px;
                            box-sizing: border-box;
                            overflow-y: scroll;
                        }
                    }
                }

                > div.send {
                    position: absolute;
                    bottom: 30px;
                    right: 30px;
                    color: #089bab;
                    padding: 6px 12px;
                    border-radius: 10px;
                    background: #ABD5DB;
                    opacity: 0.5;
                    cursor: pointer;
                    transition: opacity 0.3s linear;

                    i {
                        font-size: 30px;
                    }

                    &:hover {
                        opacity: 1;
                        transition: opacity 0.3s linear;
                    }
                }

            }
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
</style>
